import window from 'window-or-global';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';

function WidgetPaste() {
	const pasteRegexes = [
		/youtube.com\/watch\?/,
		/vimeo.com\/[0-9]+/,
		/maps.google(.[a-z]+)+\/maps/,
		/[^\.]\.wufoo\.com\/(?:forms|reports)/,
	];

	function pasteHandler(uri, node, done) {
		const urlSrc = decodeURI(uri.source);

		for (let i = 0; i < pasteRegexes.length; i++) {
			if (urlSrc.match(pasteRegexes[i])) {
				const macro = { name: 'widget', params: { url: urlSrc } };
				window.tinymce.plugins.Autoconvert.convertMacroToDom(macro, done, done);
				return;
			}
		}
		done();
	}
	window.tinymce.plugins.Autoconvert.autoConvert.addHandler(pasteHandler);
}

export default function () {
	bind('init.rte', WidgetPaste);
}
